const teethWhitening = {
  hero: {
    title: "Професионално Избелване на Зъби",
    description:
      "Преобразете усмивката си с нашите съвременни процедури за избелване на зъби. Нашите професионални процедури могат да изсветлят зъбите ви с няколко нюанса само за една сесия, премахвайки години на петна и оцветявания.",
    ctas: {
      primary: "Запишете Консултация",
      secondary: "Научете Повече",
    },
    imageAlt: "Процедура за избелване на зъби",
    callout: {
      title: "Бързи Процедури",
      body: "Повечето процедури отнемат само 60-90 минути",
    },
  },
  benefits: {
    heading: "ПРЕДИМСТВА НА ИЗБЕЛВАНЕТО НА ЗЪБИ",
    intro:
      "Открийте многобройните предимства на нашите професионални услуги за избелване на зъби",
    items: [
      {
        title: "Повишено Самочувствие",
        description:
          "По-бялата усмивка може значително да повиши вашето самочувствие и да ви направи по-уверени в социални и професионални ситуации.",
      },
      {
        title: "Драматични Резултати",
        description:
          "Нашите професионални процедури за избелване могат да изсветлят зъбите ви с няколко нюанса само за една сесия, осигурявайки незабавни резултати.",
      },
      {
        title: "Бърза Процедура",
        description:
          "За разлика от домашните средства, които отнемат седмици, за да покажат резултати, нашите процедури в кабинета обикновено отнемат само 60-90 минути.",
      },
      {
        title: "Персонализирани Решения",
        description:
          "Адаптираме нашите процедури за избелване според вашите уникални нужди и ниво на чувствителност за оптимален комфорт и резултати.",
      },
      {
        title: "Безопасно и Професионално",
        description:
          "Нашите процедури се извършват от обучени дентални специалисти, използващи висококачествени, клинично доказани избелващи агенти.",
      },
      {
        title: "Младежки Вид",
        description:
          "Ярката, бяла усмивка може да ви подмлади с години, помагайки ви да изглеждате и да се чувствате по-млади и по-жизнени.",
      },
    ],
  },
  process: {
    heading: "ПРОЦЕСЪТ НА ИЗБЕЛВАНЕ",
    intro:
      "Процедурата по избелване на зъби е съобразен с нуждите на пациента. Той е безопасен,ефективен, не предизвиква дискомфорт, резултатите са видими веднага без да  уврежда зъбния емайл.",
    steps: [
      {
        title: "Първоначална Консултация",
        description:
          "Извършваме обстоен преглед на вашите зъби и обсъждаме целите ви за избелване, за да създадем персонализиран план за лечение.",
      },
      {
        title: "Подготовка на Зъбите",
        description:
          "Зъбите ви се почистват професионално за премахване на повърхностни петна и плака преди процедурата за избелване.",
      },
      {
        title: "Нанасяне на Избелващия Гел",
        description:
          "Професионален избелващ гел се нанася внимателно върху зъбите ви, използвайки персонализирани шини за максимална ефективност.",
      },
      {
        title: "Светлинна Активация",
        description:
          "При някои процедури се използва специална светлина за ускоряване на процеса на избелване чрез активиране на съставките в гела.",
      },
      {
        title: "Крайни Резултати",
        description:
          "След процедурата ще видите незабавни резултати със забележимо по-бели и по-ярки зъби.",
      },
      {
        title: "Инструкции за Поддръжка",
        description:
          "Предоставяме насоки за поддържане на новата ви усмивка, включително препоръки за хранене и продукти за домашна грижа.",
      },
    ],
  },
  faq: {
    heading: "ЧЕСТО ЗАДАВАНИ ВЪПРОСИ",
    intro:
      "Получете отговори на често задавани въпроси за нашите процедури за избелване на зъби",
    items: [
      {
        question: "Колко време трае професионалното избелване на зъбите?",
        answer:
          "Резултатите от професионалното избелване на зъбите могат да траят от 6 месеца до 2 години, в зависимост от начина ви на живот, като пушене, консумация на кафе и практики за устна хигиена. Редовните поддържащи процедури могат да помогнат за запазване на яркостта на усмивката ви за по-дълго време.",
      },
      {
        question: "Безопасно ли е избелването на зъбите?",
        answer:
          "Да, когато се извършва от дентални специалисти, избелването на зъбите се счита за безопасно. Използваме клинично тествани продукти и внимателно оценяваме вашето орално здраве, преди да препоръчаме каквото и да е избелващо лечение, за да сме сигурни, че е подходящо за вас.",
      },
      {
        question: "Ще причини ли избелването чувствителност на зъбите?",
        answer:
          "Някои пациенти може да изпитат временна чувствителност след избелващи процедури. Въпреки това, ние вземаме предпазни мерки, за да сведем това до минимум, като използваме десенсибилизиращи агенти преди и след лечението и коригираме концентрацията на избелващия гел според вашите специфични нужди.",
      },
      {
        question: "Колко бели ще станат зъбите ми?",
        answer:
          "Резултатите варират при различните хора, но повечето пациенти виждат подобрение от 2 до 8 нюанса. Крайният резултат зависи от естествения цвят на зъбите ви, причината за оцветяването и как зъбите ви реагират на избелващите агенти.",
      },
      {
        question:
          "Каква е разликата между професионалното избелване и продуктите без рецепта?",
        answer:
          "Професионалното избелване използва избелващи агенти с по-висока концентрация, които не са достъпни без рецепта, което води до по-бързи и по-драматични резултати. Освен това, професионалните процедури са персонализирани според вашите специфични нужди и се наблюдават от дентални експерти за безопасност и ефективност.",
      },
      {
        question: "Как да поддържам избелените си зъби?",
        answer:
          "За да поддържате резултатите, препоръчваме добри практики за устна хигиена, ограничаване на консумацията на оцветяващи храни и напитки (кафе, червено вино, чай), избягване на тютюневи продукти, използване на сламка при пиене на тъмни течности и насрочване на периодични поддържащи процедури при необходимост.",
      },
    ],
  },
};

export default teethWhitening;

